export const CONSTANT = {
	THEME: {
		DARK_THEME: "darkTheme",
		LIGHT_THEME: "lightTheme",
	},
	DUMMY_PLACEHOLDER: "Lorem ipsum",
	NOT_APPLICABLE_NOTES: "NOT APPLICABLE",
	RESET_NOT_APPLICABLE_NOTES: "RESET NOT APPLICABLE",
	/** OB N/A events cascaded from Maneuver Outcome N/A — calc only, hidden from instructor comments. */
	MANEUVER_OUTCOME_NA_CASCADE_NOTES: "MANEUVER OUTCOME NOT APPLICABLE",
	RESET_MANEUVER_OUTCOME_NA_CASCADE_NOTES: "RESET MANEUVER OUTCOME NOT APPLICABLE",
	RESET_OB_NOTES: "RESET",
	DATE_FORMAT: {
		REPORT_DATE_FORMAT: "DD-MM-YYYY",
		FORMS_DATE_FORMAT: "DD-MM-YYYY hh:mm:ss A",
		DISPLAY_DATE_FORMAT: "DD-MMM-YYYY",
		INPUT_DISPLAY_DATE_FORMAT: "DD-MMM-YYYY",
		FILTER_DATE_FORMAT: "YYYY-MM-DD",
		FORMS_BE_DATE_FORMAT: "YYYY-MM-DD",
		TABLE_DATE_FORMAT: "DD/MM/YYYY h:mm:ss A",
		INPUT_DATE_FORMAT: "DD/MM/YYYY",
		LICENSE_DATE_FORMAT: "DD/MM/YY",
	},
	REPORT_STATUS: {
		COMPLETED: "completed",
		ONGOING: "ongoing",
		UPCOMING: "upcoming",
	},
	STUDENT_STATUS: {
		PENDING: "pending",
		COMPLETED: "completed",
	},
	REPORT_SESSION_DATE_FORMAT: "MM/DD/YY",
	PAGINATION: {
		DEFAULT_PAGE: 1,
		DEFAULT_SIZE: 10,
		MAX_PAGINATION_COUNT: 7,
	},
	ERROR_MESSAGES: {
		required: "This field is required.",
		pattern: "Please enter a valid value.",
		maxlength: "Must be exactly 4 letters.",
		icaoInvalid: "Must be exactly 4 letters.",
		invalidStaffId: "User not found. Please enter a valid staff number.",
		ownStaffNumber: "You cannot rate yourself. Enter another staff number.",
		duplicateManevuer: "Duplicate maneuver detected.",
		duplicateStaffId: "Duplicate staff Id detected.",
		minStaffIdlength: "Staff Id should be 7 digits, not less than 7 digits",
		// Add more error messages as needed
	},
	FIELD_VALIDATION: {
		NUMERIC: /^\d+$/,
		ALPHA_NUMERIC: /^[a-z0-9- .\/]+$/i,
		// ASCII letters + common punctuation; allow apostrophes and parentheses for names like O'Connor (John).
		NAME: /^[A-Za-z- .,@\-\/'’() ]+$/,
		ALPHABETS: /^[A-Za-z- .\/]+$/i,
		// LICENSE: /^[DB]-[A-Z0-9]{3}4$/,
		LICENSE: /^[a-z0-9- .]+$/i,
	},
	INDEXEDDB: {
		FORM: "form",
		DRAFT: "draft",
		AUTH: "auth",
		CANDIDATE: "candidate",
	},
	STORAGE_KEY: {
		EXPANDED_MANEUVER: "expanded_maneuver",
	},
	SORTING_ORDER: {
		ONE: "KNO",
		TWO: "PRO",
	},
	MAX_OB_ATTEMPT_LIMIT: 20,
	OB_LAST_ACTION: {
		PRE_SELECTED: "pre-selected",
		ADDED: "added",
		REMOVED: "removed",
		NO_ACTION: "-",
		CREATE: "create",
		EDIT: "edit",
		DISABLED: "disabled",
		RESTORE: "restore",
		RESET: "reset",
	},
	CANDIDATE_ROLE: {
		PF: "pilot_flying",
		PM: "pilot_monitoring",
		NONE: "none",
	},
	FORM_TYPE: {
		ts_1: "ts_1",
		ts_2: "ets_2",
		ts_3: "ets_3",
		ts_4: "ets_4",
		ts_5: "ets_5",
		ts_6: "ets_6",
		no_form: "none",
		cabin_crew: "cabin_crew",
		cabin_crew_instructor: "cabin_crew_instructor",
	},
	RANK: {
		pur: "pur",
		scc: "scc",
		na: "na",
	},
};

/**
 * `DraftItem.ratingFormVersion` value **2**: TS1 v2 (`app-ts1-rating-form-v2`) and TS3/5/6/cabin v2 UIs.
 * TS1 v3 uses {@link RATING_FORM_UI_VERSION_TS1_V3}. Non-TS1 legacy UIs may omit this field.
 */
export const RATING_FORM_UI_SCHEMA_VERSION = 2;

/** `DraftItem.ratingFormVersion` for TS1 **v3** (`app-ts1-rating-form-v3`). */
export const RATING_FORM_UI_VERSION_TS1_V3 = 3;

/** `DraftItem.ratingFormVersion` for TS1 **v4** (`app-ts1-rating-form-v4`) — V2 competency scoring. */
export const RATING_FORM_UI_VERSION_TS1_V4 = 4;

/** Lowercase AOC `code` → fixed aircraft registration prefix (instructor AOC). */
export const AIRCRAFT_REGISTRATION_PREFIX_BY_AOC: Record<string, string> = {
	maa: "9M-",
	aax: "9M-",
	taa: "HS-",
	tax: "HS-",
	paa: "RP-C",
	aac: "XU-",
	iaa: "PK-",
};

/** Lowercase AOC `code` → preset simulator registration / FSTD codes (instructor may still enter manually). */
export const SIMULATOR_REGISTRATION_OPTIONS_BY_AOC: Record<string, string[]> = {
	maa: ["2RUK/2UQ8", "2WAX-117184", "2WB6", "2WB8", "2UR2", "119555"],
	aax: ["MY-1004", "2T5S"],
	taa: [
		"CAE BKK#1",
		"CAE BKK#2",
		"CAE BKK#3",
		"AATC 320#1",
		"AATC 320#2",
		"AATC 320#3",
		"CAE SIM A",
		"CAE SIM B",
		"CAE SIM C",
		"CAE SIM D",
		"CAE SIM E",
		"CAE SIM F",
	],
	tax: ["CAE BKK : FSTD132", "TFT BKK : FSTD068", "AATC BKK : FSTD007"],
	paa: ["2WBD", "2RWU", "116664"],
	aac: ["2UR2", "119555"],
	iaa: ["SM SBV 15-2"],
};
